import { Duration } from "./detection-helper";

export const LOADING_INDICATOR_POSITION = { top: 8, left: 106 };

export const IDEAL_BINS = 200;

export const BIN_WIDTHS = [
  new Duration("minute", 1),
  new Duration("minute", 2),
  new Duration("minute", 4),
  new Duration("minute", 5),
  new Duration("minute", 10),
  new Duration("minute", 20),
  new Duration("minute", 30),
  new Duration("hour", 1),
  new Duration("hour", 2),
  new Duration("hour", 3),
  new Duration("hour", 4),
  new Duration("hour", 6),
  new Duration("hour", 8),
  new Duration("hour", 12),
  new Duration("day", 1),
  new Duration("day", 2),
  new Duration("day", 4),
  new Duration("day", 7),
  new Duration("day", 14),
  new Duration("day", 28),
];
/** The maximum space for the y axis labels */
export const Y_AXIS_EXTENT = 90;
/** The maximum space for the x axis labels */
export const X_AXIS_EXTENT = 20;
/** The desired height of a "row" for a nominal y-axis */
export const Y_STEP = 14;
export const AXIS_FONT = "courier-new";
export const CHART_PADDING = { top: 0, bottom: 0, left: 0, right: 90 };
/** Space taken up by the domain scroller. Best if odd number else centerLine won't be ... center */
export const DOMAIN_SCROLL_WIDTH = 19;
